import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-023c0798")

_pushScopeId("data-v-023c0798")
const _hoisted_1 = { class: "spread df-col bg-background" }
const _hoisted_2 = { class: "bg-white header df-middle px-20" }
const _hoisted_3 = { class: "flex-1 d-f m-10" }
const _hoisted_4 = { class: "section view" }
const _hoisted_5 = { class: "flex-1 df-col ml-10" }
const _hoisted_6 = { class: "section flex-1 d-f" }
const _hoisted_7 = { class: "view" }
const _hoisted_8 = { class: "flex-1 chart p-r" }
const _hoisted_9 = { class: "section account mt-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_RouterView = _resolveComponent("RouterView")
  const _component_TransitionProvider = _resolveComponent("TransitionProvider")
  const _component_Market = _resolveComponent("Market")
  const _component_Symbol = _resolveComponent("Symbol")
  const _component_Account = _resolveComponent("Account")
  const _component_Popup = _resolveComponent("Popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Header)
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.$route.meta.isBlank)
          ? (_openBlock(), _createBlock(_component_RouterView, {
              key: 0,
              name: "blank"
            }))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_RouterView, null, {
                  default: _withId(( { Component, route }) => [
                    _createVNode(_component_TransitionProvider, {
                      name: route.meta.transition
                    }, {
                      default: _withId(() => [
                        (_openBlock(), _createBlock(_KeepAlive, { include: $setup.cacheList }, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ], 1032, ["include"]))
                      ]),
                      _: 2
                    }, 1032, ["name"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_Market)
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_Symbol)
                  ])
                ]),
                _createVNode("div", _hoisted_9, [
                  _createVNode(_component_Account)
                ])
              ])
            ], 64))
      ])
    ]),
    _createVNode(_component_Popup)
  ], 64))
})